import { render } from "./ExportKlaviyo.vue?vue&type=template&id=fa892368&scoped=true"
import script from "./ExportKlaviyo.vue?vue&type=script&lang=js"
export * from "./ExportKlaviyo.vue?vue&type=script&lang=js"

import "./ExportKlaviyo.vue?vue&type=style&index=0&id=fa892368&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa892368"]])

export default __exports__